<empresa tipo='P' titulo="Gestão de Parcerias" rotaCadastrar='empresasparceiras/cadastrar'></empresa>
